import { Grid, Typography, CircularProgress } from "@mui/material";
import PCheck from "../../components/pos/PCheck";
import PConfirm from "../../components/pos/PConfirm";
import PDialog from "../../components/pos/PDialog";
import PSelect from "../../components/pos/PSelect";
import PTagsInput from "../../components/pos/PTagsInput";
import PText from "../../components/pos/PText";
import db from "../../db/db";
import React, { useEffect, useState } from "react";
import API from "../../utils/API";
import { PricingUtils } from "../../utils/PricingUtils";
import { SyncUtils } from "../../utils/SyncUtils";
import { useTranslation } from "react-i18next";

export default function ServiceCrud(props) {
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const { t } = useTranslation();
  const translate = t;
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [code, setCode] = useState("AUTO");
  const [codeError, setCodeError] = useState("");
  const [deptId, setDeptid] = useState("");
  const [deptIdError, setDeptidError] = useState("");
  const [deptIdOptions, setDeptidOptions] = useState([]);
  const [taxId, setTaxid] = useState("");
  const [taxIdError, setTaxidError] = useState("");
  const [taxIdOptions, setTaxidOptions] = useState([]);
  const [vendorId, setVendorid] = useState("");
  const [vendorIdError, setVendoridError] = useState("");
  const [vendorIdOptions, setVendoridOptions] = useState([]);
  const [productInfoField1, setProductinfofield1] = useState([]);
  const [productinfofield2, setproductinfofield2] = useState([]);
  const [serviceCharge, setServicecharge] = useState("");
  const [serviceChargeError, setServicechargeError] = useState("");
  const [includeTax, setIncludetax] = useState(true);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [label1, setLabel1] = useState("Item Name");
  const [label2, setLabel2] = useState("Serial No / Model");
  const [label3, setLabel3] = useState("Item Details");
  const [label4, setLabel4] = useState("Item Notes");
  const [label5, setLabel5] = useState("Complaints");
  const [label6, setLabel6] = useState("Complaint Notes");

  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showServiceCrudWindow: showServiceCrudWindow,
  };

  useEffect(() => {
    if (origObject) {
      setWindowTitile(origObject.name);
    }
  }, [origObject]);

  useEffect(() => {
    populateDept();
    populateVendor();
    populateTax();
  }, []);

  useEffect(() => {
    if (liveValidation && name === "") setNameError("Name is Required");
    else setNameError("");
  }, [name]);
  useEffect(() => {
    if (liveValidation && code === "") setCodeError("Code is Required");
    else setCodeError("");
  }, [code]);
  useEffect(() => {
    if (liveValidation && deptId === "") setDeptidError("Deptid is Required");
    else setDeptidError("");
  }, [deptId]);
  useEffect(() => {
    if (liveValidation && taxId === "") setTaxidError("Taxid is Required");
    else setTaxidError("");
  }, [taxId]);
  useEffect(() => {
    if (liveValidation && vendorId === "")
      setVendoridError("Service Provider is Required");
    else setVendoridError("");
  }, [vendorId]);

  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  async function populateDept() {
    db.category
      .where("level")
      .equals(0)
      .toArray(function (data) {
        let dat = [];
        for (let i = 0; i < data.length; i++) {
          if (!data[i].parent_id) {
            dat.push({
              id: data[i].id,
              name: data[i].name,
              code: data[i].catCode,
            });
          }
        }
        setDeptidOptions(dat);
      });
  }

  async function populateTax() {
    db.tax.toArray(function (data) {
      let dat = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].parent_id) {
          dat.push({ id: data[i].id, name: data[i].name, rate: data[i].rate });
        }
      }
      setTaxidOptions(dat);
    });
  }

  async function populateVendor() {
    db.vendor.toArray(function (data) {
      let dat = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].parent_id) {
          dat.push({ id: data[i].id, name: data[i].name });
        }
      }
      setVendoridOptions(dat);
    });
  }

  function showServiceCrudWindow(productId) {
    if (productId == null) {
      resetFields();
      setMode("create");
      setLiveValidation(false);
      setOpenWindow(true);
      setWindowTitile(translate("New Service"));
    } else {
      setMode(
        props.context.privileges.service_edit ||
          props.context.privileges.service_delete
          ? "edit"
          : "view"
      );
      populateProduct(productId);
    }
  }
  async function populateProduct(id) {
    {
      try {
        let { data } = await API.get("/api/v1/product/" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          "Not able to retrive Service data from server"
        );
      }
    }
  }

  function populateData(bean) {
    setMode(
      props.context.privileges.service_edit ||
        props.context.privileges.service_delete
        ? "edit"
        : "view"
    );
    console.log(bean);
    setName(bean.name);
    setCode(bean.code);
    setDeptid(bean.deptId ? { id: bean.deptId, name: bean.deptName } : null);

    setTaxid(
      bean.taxId
        ? {
          id: bean.taxId,
          name: bean.taxBean.name,
        }
        : null
    );
    setVendorid(
      bean.vendorId ? { id: bean.vendorId, name: bean.vendorName } : null
    );

    setProductinfofield1(JSON.parse(bean.productInfoField1));
    setproductinfofield2(JSON.parse(bean.productInfoField2));

    setServicecharge(bean.productPricingBeanList[0].price);
    setIncludetax(bean.includeTaxInPrice);

    if (bean.productInfoField3) {
      let o = JSON.parse(bean.productInfoField3);
      setLabel1(o.label1);
      setLabel2(o.label2);
      setLabel3(o.label3);
      setLabel4(o.label4);
      setLabel5(o.label5);
      setLabel5(o.label6);
    }

    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setNameError("");
    setCode("");
    setCodeError("");
    setDeptid("");
    setDeptidError("");
    setTaxid("");
    setTaxidError("");
    setVendorid("");
    setVendoridError("");
    setProductinfofield1([]);
    setproductinfofield2([]);
    setServicecharge("");
    setServicechargeError("");
    setIncludetax(false);
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: "Are You Sure",
      message: "Are you sure to delete the Service :" + origObject.name + " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/product/" + origObject.id);
        props.showMessage("warning", "Service " + name + " got Removed");
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", "Not able to Delete Service");
      }
    }
  }


  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/product", payload);
        props.showMessage("success", "Saved Successfully");
        SyncUtils.requestSync(result.headers);
        props.onRefresh();
        setOrigObject(result.data);
        populateData(result.data);
        //setOpenWindow(false);
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", "Not able to Save Service");
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      if (obj.field === "code") {
        setCodeError(obj.message);
      }
      if (obj.field === "deptId") {
        setDeptidError(obj.message);
      }
      if (obj.field === "taxId") {
        setTaxidError(obj.message);
      }
      if (obj.field === "vendorId") {
        setVendoridError(obj.message);
      }

      if (obj.field === "serviceCharge") {
        setServicechargeError(obj.message);
      }

      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);

    let bean = {
      name: name,
      code: code ? code : "AUTO",
      deptId: deptId ? deptId.id : null,
      subDeptId: null,
      catId: null,
      subCatId: null,
      vendorId: vendorId ? vendorId.id : null,
      taxId: taxId ? taxId.id : null,
      shortName: name,
      localName: name,
      uom: null,
      unitSymbol: "",
      currentStock: "0",
      isOpenPrice: false,
      isOpenQty: false,
      isDiscounted: false,
      includeTaxInPrice: includeTax,
      includeDiscountInPrice: false,
      isFastItem: "",
      productPricingBeanList: [],
      productFiles: [],
      kitItems: [],
      isKit: false,
      isStockItem: false,
      isExpandKitDuringSale: false,
      productInfoField1: productInfoField1
        ? JSON.stringify(productInfoField1)
        : null,
      productInfoField2: productinfofield2
        ? JSON.stringify(productinfofield2)
        : null,
      id: null,
      intVersion: 0,
      productType: "S",
      productInfoField3: getCustomLabels(),
    };

    function getCustomLabels() {
      let o = {};
      o["label1"] = label1;
      o["label2"] = label2;
      o["label3"] = label3;
      o["label4"] = label4;
      o["label5"] = label5;
      o["label6"] = label6;
      return JSON.stringify(o);
    }

    let result = PricingUtils.derivePrice(
      2, //TODO dynamic decial
      0, //COst
      serviceCharge, //Price
      includeTax, //Inc tax
      taxId ? taxId.rate : 0, //Tax Rate //todo
      false, //Inc Promotion
      0, // Promotion Per
      null, //Promoton Amt
      false, //Is Discounted
      1,
      false
    );

    bean.productPricingBeanList.push({
      unitType: "EACH",
      factor: 1,
      cost: 0,
      margin: result.netMargin == "NaN" ? 0 : result.netMargin,
      marginPer: result.marginPer == "NaN" ? 0 : result.marginPer,
      position: 1,
      price: serviceCharge,
      productBarcodeBeanList: [],
      promotionIds: [],
      pricingLevelBeanList: [],
    });

    if (mode == "create") {
      bean["id"] = null;
      bean["intVersion"] = 0;
    }
    if (mode == "edit") {
      bean["id"] = origObject.id;
      bean["intVersion"] = origObject.intVersion;
    }
    return bean;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError("Service Name is Required");
      flag = false;
    }
    if (!code || code === "") {
      setCodeError("Service Code is Required");
      flag = false;
    }
    if (!deptId || deptId === "") {
      setDeptidError("Department is Required");
      flag = false;
    }
    if (!taxId || taxId === "") {
      setTaxidError("Tax is Required");
      flag = false;
    }
    if (!vendorId || vendorId === "") {
      setVendoridError("Service Provider is Required");
      flag = false;
    }

    if (!serviceCharge || serviceCharge === "") {
      setServicechargeError("Service Charge is Required");
      flag = false;
    }

    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  const content = (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1"> Service Name</Typography>
                </td>
                <td>
                  <PText
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">Service Code</Typography>
                </td>
                <td>
                  <PText
                    value={code}
                    error={codeError}
                    onChange={(e) => setCode(e.target.value)}
                  ></PText>
                </td>
              </tr>

              <tr>
                <td>
                  <Typography variant="body1">Service Charge</Typography>
                </td>
                <td>
                  <PText
                    value={serviceCharge}
                    error={serviceChargeError}
                    type="number"
                    onChange={(e) => setServicecharge(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">Tax Included </Typography>
                </td>
                <td>
                  <PCheck
                    onChange={(value) => setIncludetax(value)}
                    checked={includeTax}
                    label=""
                  ></PCheck>
                </td>
              </tr>

              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} sm={6}>
          <table width="100%">
            <tbody>
              <tr>
                <td style={{ width: "150px" }}>
                  <Typography variant="body1">Department </Typography>
                </td>
                <td>
                  <PSelect
                    options={deptIdOptions}
                    value={deptId}
                    errorMessage={deptIdError}
                    onChange={(event, newValue) => {
                      setDeptid(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">Tax</Typography>
                </td>
                <td>
                  <PSelect
                    options={taxIdOptions}
                    value={taxId}
                    errorMessage={taxIdError}
                    onChange={(event, newValue) => {
                      setTaxid(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">Service Provider</Typography>
                </td>
                <td>
                  <PSelect
                    options={vendorIdOptions}
                    value={vendorId}
                    errorMessage={vendorIdError}
                    onChange={(event, newValue) => {
                      setVendorid(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
            </tbody>
          </table>{" "}
        </Grid>
        <Grid item xs={12} width="100%">
          <table>
            <tbody>
              <tr>
                <td style={{ whiteSpace: "nowrap" }}>
                  <Typography variant="body1">Item Types</Typography>
                </td>
                <td width="100%">
                  <PTagsInput
                    value={productInfoField1}
                    onChange={(e) => {
                      setProductinfofield1(e);
                    }}
                    placeHolder={productInfoField1 > 0 ? "" : "Enter"}
                  />
                </td>
              </tr>
              <tr>
                <td style={{ whiteSpace: "nowrap" }}>
                  <Typography variant="body1">Service Details</Typography>
                </td>
                <td width="100%">
                  <PTagsInput
                    value={productinfofield2}
                    onChange={(e) => {
                      setproductinfofield2(e);
                    }}
                    placeHolder={productinfofield2 > 0 ? "" : "Enter"}
                  />
                </td>
              </tr>
              <tr>
                <td style={{ whiteSpace: "nowrap" }}>
                  <Typography variant="body1">Custom Label 1 </Typography>
                </td>
                <td width="100%">
                  <PText
                    value={label1}
                    onChange={(e) => setLabel1(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td style={{ whiteSpace: "nowrap" }}>
                  <Typography variant="body1">Custom Label 2 </Typography>
                </td>
                <td width="100%">
                  <PText
                    value={label2}
                    onChange={(e) => setLabel2(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td style={{ whiteSpace: "nowrap" }}>
                  <Typography variant="body1">Custom Label 3 </Typography>
                </td>
                <td width="100%">
                  <PText
                    value={label3}
                    onChange={(e) => setLabel3(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td style={{ whiteSpace: "nowrap" }}>
                  <Typography variant="body1">Custom Label 4 </Typography>
                </td>
                <td width="100%">
                  <PText
                    value={label4}
                    onChange={(e) => setLabel4(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td style={{ whiteSpace: "nowrap" }}>
                  <Typography variant="body1">Custom Label 5 </Typography>
                </td>
                <td width="100%">
                  <PText
                    value={label5}
                    onChange={(e) => setLabel5(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td style={{ whiteSpace: "nowrap" }}>
                  <Typography variant="body1">Custom Label 6 </Typography>
                </td>
                <td width="100%">
                  <PText
                    value={label6}
                    onChange={(e) => setLabel6(e.target.value)}
                  ></PText>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"lg"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          hideSave={
            (!props.context.privileges.service_edit &&
              props.context.privileges.service_delete) ||
              mode === "view"
              ? mode === "create"
                ? false
                : true
              : false
          }
          onDelete={props.context.privileges.service_delete ? onDelete : false}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
